import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import queue from './queue'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    queue
  },
  plugins: [
    createPersistedState({
      key: 'agc_v001',
      paths: [
        'auth.user',
        'auth.token',
        'auth.roles',
        'auth.login.email',
        'auth.login.username'
      ]
    })
  ]
})

export default store
